import { DependencyList, useCallback } from 'react';
import { useUpdateEffect } from 'ahooks';

const useDebounce = (actionFunc, effectList: DependencyList, delay: number) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const func = useCallback(actionFunc, effectList);

  useUpdateEffect(() => {
    const timer = setTimeout(() => func.call(), delay);
    return () => clearTimeout(timer);
  }, [delay, func]);
};

export default useDebounce;
